module.exports = __webpack_public_path__ + "img/pl.484a2334.svg";